import { render, staticRenderFns } from "./managementsystem.vue?vue&type=template&id=e4682406&scoped=true&"
import script from "./managementsystem.vue?vue&type=script&lang=js&"
export * from "./managementsystem.vue?vue&type=script&lang=js&"
import style0 from "./managementsystem.vue?vue&type=style&index=0&id=e4682406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4682406",
  null
  
)

export default component.exports